<template>
  <div style="margin-bottom: 30px">
    <div class="is-size-5" style="font-variant: small-caps;">
      <translate>
        {{ type.charAt(0).toUpperCase() + type.slice(1) }}
      </translate>
    </div>
    <div class="is-size-4 has-text-weight-semibold">
      {{ title }}
    </div>
    <span class="is-size-7">
      <template v-if="createUser || createDate">
        <translate>form.header.created</translate>
        <template v-if="createDate">
          <b-tooltip :label="asTimestamp(createDate)" dashed> {{ asFromNow(createDate) }}</b-tooltip>
        </template>
        <template v-if="createUser">
          <translate>form.header.by</translate> {{ createUser }}
        </template>
        <span style="margin-left: -0.4ch;">,</span>
      </template>
      <template v-if="updateUser || updateDate">
        <translate>form.header.lastEdited</translate>
        <template v-if="updateDate">
          <b-tooltip :label="asTimestamp(updateDate)" dashed> {{ asFromNow(updateDate) }}</b-tooltip>
        </template>
        <template v-if="updateUser">
          <translate>form.header.by</translate> {{ updateUser }}
        </template>
      </template>
    </span>
  </div>
</template>

<script>

import DateTimeHelper from '@/components/mixins/DateTimeHelper'

export default {
  mixins: [DateTimeHelper],
  props: [ 'type', 'title', 'createUser', 'createDate', 'updateUser', 'updateDate' ]
}
</script>



// WEBPACK FOOTER //
// src/components/EntityHeader.vue